module.exports = __webpack_public_path__ + "static/media/illus-group-rect.663cd15f.png";